import dayjs from 'dayjs';
import timezonePlugin from 'dayjs/plugin/timezone';
import utcPlugin from 'dayjs/plugin/utc';

dayjs.extend(timezonePlugin);
dayjs.extend(utcPlugin);

export const timezone = dayjs.tz.guess();
